import React, { Component } from 'react';
import { css } from 'aphrodite';

import { Flexbox } from './Styles'

import Impact from './models/Impact';

class ScorePicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      c: 200,
      p: 5,
      q: 5
    };
  }

  render() {
    return(
      <form onSubmit={this.handleSubmit.bind(this)}>
        <div className={css(Flexbox.column, Flexbox.axisCenter, Flexbox.crossCenter, Flexbox.fillVertical)}>
          <label>
            Money:
            <input type="text" value={this.state.c} onChange={this.handleCChange.bind(this)} />
          </label>
          <label>
            Preparedness:
            <input type="text" value={this.state.p} onChange={this.handlePChange.bind(this)} />
          </label>
          <label>
            Quality of Life:
            <input type="text" value={this.state.q} onChange={this.handleQChange.bind(this)} />
          </label>
          <input type="submit" value="Play" />
        </div>
      </form>
    );
  }

  handleCChange(event) {
    this.setState({c: event.target.value});
  }


  handlePChange(event) {
    this.setState({p: event.target.value});
  }

  handleQChange(event) {
    this.setState({q: event.target.value});
  }

  handleSubmit(event) {
    this.props.onComplete(new Impact(this.state.c, this.state.p, this.state.q));
    event.preventDefault();
  }
}

export default ScorePicker;



// WEBPACK FOOTER //
// ./src/ScorePicker.js